module.exports = __webpack_public_path__ + "img/icon.9d41cd8c.png";